const Loading=()=>{
    return(
<section style={{padding: 15}} className={'loading-icon'}>
    <img style={{heigth: 100, width:100}} src={'/images/loading-ring.gif'} alt={'loading'} />
</section>
    )
}
export default Loading;